import { useEffect } from 'react';

import { useWidgetInstanceRegistry } from './WidgetInstanceRegistryProvider';
import type { WidgetInstanceCapabilities } from './types';

/** Register instance capabilities on mount and unregister on unmount. */
export function useRegisterWidgetInstance(
  capabilities: WidgetInstanceCapabilities | null
): void {
  const { registerInstance, unregisterInstance } = useWidgetInstanceRegistry();

  useEffect(() => {
    if (!capabilities) {
      return;
    }

    registerInstance(capabilities);

    return () => unregisterInstance(capabilities.dashboardElementId);
  }, [capabilities, registerInstance, unregisterInstance]);
}
